import styled, { css } from 'styled-components'

export const base = css`
    outline: none;
    background: #FFFFFF;
    padding: 14px 10px;
    border: 1px solid #ADAABF;

    border: 1px solid #E8E8E8;
    border-radius: 4px;

    font-size: 1.2rem;
    line-height: 150%;
    width: 100%;

    color: #707070;
    font-family: inherit;

    &:focus {
        box-shadow: 0px 3px 6px #00000029;
    }

    &:disabled {
        background: #E8E8E8 0% 0% no-repeat padding-box;
    }
`

export const Label = styled.span`
    font-size: 1.2rem;
    color: #707070;
    margin-bottom: 1rem;
    display: inline-block;
    font-weight: 600;
`

export const LabelContainer = styled.label`
    width: 100%;
    position: relative;
    display: inline-block;

    ${props => props.pointer && css`
        cursor: pointer;
        display: flex;
        align-items: center;

        ${Label} {
            margin: 0;
            cursor: pointer;
        }
    `}
`

export const Leading = styled.span`
    color: #707070;
    font-size: 1.2rem;
    font-weight: bold;
    width: 18px;
    position: absolute;
    top: 45px;
    user-select: none;

    

    ${props => props.right ? css`
        right: 10px;

        & + input, + textarea, + select {
            padding-right: 30px;
        }
    ` : css`
        left: 10px;
        
        & + input, + textarea, + select {
            padding-left: 30px;
        }
    `}
`

export const Info = styled.div`
    color: #707070;
    font-size: 1.2rem;
    font-weight: bold;
    text-align: right;
`


// WEBPACK FOOTER //
// ./src/SPRINTA/v3/Form/style.js